"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactFeather = require("react-feather");
var _Tiktok = _interopRequireDefault(require("./../../icons/Tiktok"));
var _Twitter = _interopRequireDefault(require("./../../icons/Twitter"));
var _helpers = require("./../../utils/helpers");
var _ImageReplacementAnchor = _interopRequireDefault(require("../utils/ImageReplacementAnchor"));
var _SocialLinksModule = _interopRequireDefault(require("./../../scss/navigations/SocialLinks.module.scss"));
const platformIconMap = new Map([['facebook', _reactFeather.Facebook], ['instagram', _reactFeather.Instagram], ['linkedin', _reactFeather.Linkedin], ['youtube', _reactFeather.Youtube], ['tiktok', _Tiktok.default], ['twitter', _Twitter.default]]);
function SocialLinks({
  onClickHandler = () => true,
  size = 1.4,
  showHeader = false,
  headerText = 'Follow Us',
  platforms = [{
    platform: 'facebook',
    url: 'https://www.facebook.com/EWScrippsCo'
  }, {
    platform: 'twitter',
    url: 'https://twitter.com/EWScrippsCo'
  }, {
    platform: 'instagram',
    url: 'https://www.instagram.com/EWScrippsCo'
  }, {
    platform: 'linkedin',
    url: 'https://www.linkedin.com/company/the-e-w-scripps-company'
  }]
}) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_SocialLinksModule.default['social-links'], 'social-links'])
  }, showHeader && /*#__PURE__*/_react.default.createElement("h4", {
    className: (0, _helpers.classes)([_SocialLinksModule.default['social-links__header'], 'social-links__header'])
  }, headerText), platforms.map((item, index) => {
    const {
      platform,
      url
    } = item;
    const Icon = item !== null && item !== void 0 && item.image ? item.image : platformIconMap.get(platform);
    if (item !== null && item !== void 0 && item.image) return /*#__PURE__*/_react.default.createElement(_ImageReplacementAnchor.default, {
      image: item.image,
      text: platform,
      target: "_blank",
      href: url,
      height: size,
      classname: (0, _helpers.classes)([_SocialLinksModule.default['social-link'], 'social-link', `social-link--${platform}`]),
      key: `social-link-${platform}`
    });
    return /*#__PURE__*/_react.default.createElement("a", {
      href: url,
      className: (0, _helpers.classes)([_SocialLinksModule.default['social-link'], 'social-link', `social-link--${platform}`]),
      onClick: onClickHandler,
      target: "_blank",
      rel: "noreferrer",
      key: `social-link-${platform}`
    }, /*#__PURE__*/_react.default.createElement("i", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, platform), /*#__PURE__*/_react.default.createElement(Icon, (0, _extends2.default)({
      className: (0, _helpers.classes)([_SocialLinksModule.default['social-link__icon'], 'social-link__icon']),
      size: `${size}rem`
    }, item.svgAttrs))));
  }));
}
var _default = exports.default = SocialLinks;